import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        "flex w-full box-border resize-none border rounded-lg bg-white field-sizing-content border-secondary px-3 py-2 text-body-sm text-primary ring-offset-white focus:outline-none focus:border-link placeholder:text-tertiary disabled:cursor-not-allowed disabled:bg-tertiary disabled:text-tertiary",
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";

export { Textarea };
